import React from 'react'
import Slick from 'react-slick'
import InlineSVG from 'components/InlineSVG'
import PropTypes from 'prop-types'

import 'components/Slider/slick.css'

const SliderPrevArrow = (props) => {
  const { className, style, onClick } = props
  return (
    <div
      className={className}
      style={{ ...style }}
      onClick={onClick}
    >
      <InlineSVG icon='caret-left' />
    </div>
  )
}

SliderPrevArrow.propTypes = {
  className: PropTypes.string,
  style: PropTypes.object,
  onClick: PropTypes.func
}

const SliderNextArrow = (props) => {
  const { className, style, onClick } = props
  return (
    <div
      className={className}
      style={{ ...style }}
      onClick={onClick}
    >
      <InlineSVG icon='caret-right' />
    </div>
  )
}

SliderNextArrow.propTypes = {
  className: PropTypes.string,
  style: PropTypes.object,
  onClick: PropTypes.func
}

const Carousel = (props) => {
  const settings = {
    arrows: true,
    dots: false,
    adaptiveHeight: true,
    focusOnSelect: false,
    infinite: true,
    autoplay: false,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    prevArrow: <SliderPrevArrow />,
    nextArrow: <SliderNextArrow />
  }

  const slides = props.images.map((image, idx) => (
    <div key={idx}>
      <img src={image.src} alt='' />
    </div>
  ))

  return (
    <div className='gallery__carousel'>
      <Slick {...settings}>
        {slides}
      </Slick>
    </div>
  )
}

Carousel.propTypes = {
  images: PropTypes.array.isRequired
}

export default Carousel



// WEBPACK FOOTER //
// ./src/components/Page/Content/Gallery/Carousel/index.js